import { NavLink, Route, Routes } from "react-router-dom";
import PayBills from "./PayBills";
import History from "./payments/history/History";
import TransactionDetails from "./payments/history/TransactionDetails";
import Send from "./Send";
import Loans from "./Loans";
import Orders from "./Orders";

const Payments = () => {
  return (
    <div className="flex flex-col">
      <div className="flex items-center p-5 md:px-10 py-4">
        <NavLink
          to="history"
          className="p-3 px-5 text-sm rounded-lg font-medium max-w-fit flex items-center gap-2 transition c-nav-link"
        >
          Transactions
        </NavLink>
        {/* <NavLink
          to="send"
          className="p-3 px-5 text-sm rounded-lg font-medium max-w-fit flex items-center gap-2 transition c-nav-link"
        >
          Send
        </NavLink> */}
        <NavLink
          to="loans"
          className="p-3 px-5 text-sm rounded-lg font-medium max-w-fit flex items-center gap-2 transition c-nav-link"
        >
          Loans
        </NavLink>
        <NavLink
          to="bills"
          className="p-3 px-5 text-sm rounded-lg font-medium max-w-fit flex items-center gap-2 transition c-nav-link"
        >
          Bills
        </NavLink>
        <NavLink
          to="orders"
          className="p-3 px-5 text-sm rounded-lg font-medium max-w-fit flex items-center gap-2 transition c-nav-link"
        >
          Orders
        </NavLink>

        <div className="flex-1"></div>
      </div>
      <Routes>
        <Route path="/" element={<History />} />
        <Route path="/history" element={<History />} />
        <Route path="/send/*" element={<Send />} />
        <Route path="/orders/*" element={<Orders />} />
        <Route path="/bills/*" element={<PayBills />} />
        <Route path="/loans/*" element={<Loans />} />
        <Route path="/history/tx/:id" element={<TransactionDetails />} />
      </Routes>
    </div>
  );
};

export default Payments;
